import cn from 'classnames/bind';
import React, { useCallback, useState } from 'react';
import { Button } from '@consta/uikit/Button';
import { connect } from 'react-redux';
import { loadAuthUser } from 'src/redux/features/auth/actions';
import { IAuthUser } from 'src/redux/features/auth/types';
import { TextField } from '@consta/uikit/TextField';
import { Text } from '@consta/uikit/Text';
import { Informer } from '@consta/uikit/Informer';
import styles from './styles.styl';
import {
  userAuthLoadedSelector,
  userAuthRejectedSelector,
  usersAuthPendingSelector,
} from 'src/redux/features/auth/selectors';
import { State } from 'src/redux/reducer';
import { VisiblePassword } from 'src/utils/enum';
import { IconEyeClose } from '@consta/uikit/IconEyeClose';
import { IconEye } from '@consta/uikit/IconEye';

const cx = cn.bind(styles);

export interface IAuthModalProps {
  loadAuthUser?: (auth: IAuthUser) => void;
  userAuthLoadedSelector?: boolean;
  userAuthRejectedSelector?: boolean;
  usersAuthPendingSelector?: boolean;
}

const AuthModal: React.FC<IAuthModalProps> = ({
  loadAuthUser,
  // userAuthLoadedSelector,
  userAuthRejectedSelector,
  usersAuthPendingSelector,
}) => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [visible, setVisible] = useState(VisiblePassword.Password);

  const authUser = () => {
    loadAuthUser({ login, password });
  };

  const passwordVisible = useCallback(() => {
    return (
      <Button
        size="s"
        view="clear"
        onlyIcon
        onClick={() => {
          visible === VisiblePassword.Password
            ? setVisible(VisiblePassword.Text)
            : setVisible(VisiblePassword.Password);
        }}
        iconRight={
          visible === VisiblePassword.Password ? IconEyeClose : IconEye
        }
      />
    );
  }, [visible]);

  return (
    <div className={cx('AuthModal')}>
      <div className={cx('AuthModal__body')}>
        <Text size="2xl" weight="semibold" className={cx('AuthModal__title')}>
          Вход в систему
        </Text>
        <TextField
          onChange={({ value }) => setLogin(value)}
          className={cx('AuthModal__login')}
          value={login}
          label="Логин"
          placeholder="Введите логин"
          width="full"
        />
        <TextField
          onChange={({ value }) => setPassword(value)}
          value={password}
          label="Пароль"
          placeholder="Введите пароль"
          type={visible}
          rightSide={passwordVisible}
          width="full"
        />
        {userAuthRejectedSelector && (
          <Informer
            label="Проверьте правильность введенных данных"
            className={cx('AuthModal__informer')}
            view="bordered"
            status="alert"
          />
        )}
      </div>
      <Button
        onClick={authUser}
        label="Войти"
        width="full"
        loading={usersAuthPendingSelector}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  loadAuthUser: (auth: IAuthUser) => dispatch(loadAuthUser(auth)),
});

const mapStateToProps = (state: State, props: IAuthModalProps) => ({
  userAuthLoadedSelector: userAuthLoadedSelector(state, props),
  userAuthRejectedSelector: userAuthRejectedSelector(state),
  usersAuthPendingSelector: usersAuthPendingSelector(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthModal);
